import NavComponent from '@/components/Nav'
import FooterComponent from '@/components/Footer'
import UsermenuComponent from '@/components/Usermenu'
import commonMixin from '@/mixin/common'
import { regionData, CodeToText } from 'element-china-area-data'
import {addressAdd, addressList, addressDelete, addressUpdate} from '@/api/server/address'
export default {
  name: 'UserIndexPage',
  mixins: [commonMixin],
  data () {
    return {
      dialogAddrVisible: false,
      options: regionData,
      valueArea: null,
      form: {
          name: null,
          tel: null,
          province: null,
          city: null,
          region: null,
          province_code: null,
          city_code: null,
          region_code: null,
          address: null,
          is_default: 0,
          _id: 0,
      },
      list: [],
      total: null,
      isDefault: 0,
    }
  },
  components: {
    'nav-component': NavComponent,
    'footer-component': FooterComponent,
    'user-menu': UsermenuComponent
  },
  methods: {
    onEdit (item) {
        if (!item || !item.id) {
            return false
        }
        let editInfo = item
        editInfo.is_default = item.isDefault ? 1 : 0
        this.isDefault = item.isDefault ? 1 : 0
        this.form = editInfo
        this.valueArea = [
            String(item.province_code),
            String(item.city_code),
            String(item.region_code)
        ]
        this._id = item.id
        this.dialogAddrVisible = true
    },
    onDelete (item) {
        if (!item || !item.id) {
            return false
        }
        addressDelete(item.id).then( (res)=> {
            if (res.code === 200) {
                this.success('删除成功')
                this.list = res.data
            } else {
                this.warning(res.message)
            }
        })
    },
    onSubmit () {
        if (this._id) {
            this.updateAddress()
        } else {
            this.saveAddress()
        }
    },
    updateAddress () {
        if (!this.form.name) {
            this.error('请正确填写收货人')
            return false
        }
        if (!this.isPhone(this.form.tel)) {
            this.error('请正确填写手机号码')
            return false
        }
        if (!this.form.address) {
            this.error('请正确填写详细地址')
            return false
        }
        // let value = this.valueArea
        // if (value && value[0] && value[1] && value[2]) {
        //     this.form.province = CodeToText[value[0]]
        //     this.form.city = CodeToText[value[1]]
        //     this.form.region = CodeToText[value[2]]
        //     this.form.province_code = value[0]
        //     this.form.city_code = value[1]
        //     this.form.region_code = value[2]
        // } else {
        //     this.warning('请正确选择区域')
        //     return false
        // }
        // if (!this.form.province || !this.form.city || !this.form.region) {
        //     this.warning('请正确选择区域')
        //     return false
        // }
        let form = this.form
        form['is_default'] = this.isDefault
        addressUpdate(this.form).then( (res) => {
            if (res.code === 200) {
                this.success('保存成功')
                this.list = res.data
                this.dialogAddrVisible = false
                this._resetAddress()
            } else {
                this.warning(res.message)
            }
        })
    },
    saveAddress () {

        if (!this.form.name) {
            this.error('请正确填写收货人')
            return false
        }
        if (!this.isPhone(this.form.tel)) {
            this.error('请正确填写手机号码')
            return false
        }
        if (!this.form.address) {
            this.error('请正确填写详细地址')
            return false
        }
        // let value = this.valueArea
        // if (value && value[0] && value[1] && value[2]) {
        //     this.form.province = CodeToText[value[0]]
        //     this.form.city = CodeToText[value[1]]
        //     this.form.region = CodeToText[value[2]]
        //     this.form.province_code = value[0]
        //     this.form.city_code = value[1]
        //     this.form.region_code = value[2]
        // } else {
        //     this.warning('请正确选择区域')
        //     return false
        // }
        // if (!this.form.province || !this.form.city || !this.form.region) {
        //     this.warning('请正确选择区域')
        //     return false
        // }
        form['is_default'] = this.isDefault
        addressAdd(this.form).then( (res) => {
            if (res.code === 200) {
                this.success('保存成功')
                this.list = res.data
                this.dialogAddrVisible = false
                this._resetAddress()
            } else {
                this.warning(res.message)
            }
        })
      
    },
    onAdd () {
        this._resetAddress()
        this.dialogAddrVisible = true
    },
    _resetAddress () {
        this._id = 0
        this.valueArea = null
        this.form = {
            name: null,
            tel: null,
            province: null,
            city: null,
            region: null,
            province_code: null,
            city_code: null,
            region_code: null,
            address: null,
            is_default: 0
        }
    },
    handleChangeCity (value) {
        // console.log('value', value)
    },
    handleClick (tab, event) {
      console.log(tab, event)
    },
    _getList () {
        addressList().then( (res) => {
            if (res.code === 200) {
                this.list = res.data
            } else {
                this.warning(res.message)
            }
        })
    },
    reset () {
        this.list = []
        this.total = []
        this.dialogAddrVisible = false
        this._getList()
    },
    handleRoute (route) {
        if (route.name === 'user-address') {
            this.reset()
        }
    }
  },
  watch: {
    '$route' (to, from) {
      this.handleRoute(to)
    }
  },
  mounted: function () {
    this.handleRoute(this.$route)
  }
}